import { render, staticRenderFns } from "./contact_details_modal.vue?vue&type=template&id=02a4f58c&scoped=true"
import script from "./contact_details_modal.vue?vue&type=script&lang=js"
export * from "./contact_details_modal.vue?vue&type=script&lang=js"
import style0 from "./contact_details_modal.vue?vue&type=style&index=0&id=02a4f58c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a4f58c",
  null
  
)

export default component.exports